module.exports = __webpack_public_path__ + "img/asset4.e1272611.png";